import React, { Component } from "react"
import { Link } from "gatsby"
import "./index.css"
import BlogHeroSection from "./hero-section"
import BlogListingSection from "./blog-listing-section"

class MorosoftBlogs extends Component {
  render() {
    return (
      <React.Fragment>
        <BlogHeroSection />
        {/* <section id="coming-soon">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="coming-soon">
                  <h1>Coming Soon..!!!!!!</h1>
                  <h2>Stay tuned. Something great coming up.</h2>
                  <Link className="btn back-btn" to="/">
                    Go To Homepage
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        <BlogListingSection />
      </React.Fragment>
    )
  }
}

export default MorosoftBlogs
